import { map } from 'rxjs/operators';
import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';

import { SessionService } from '../../_services/session.service';

// import { SaikuService } from '../../_services/volumenes/index';

import { Perfil, Respuesta, User } from '../../_models/shared/_index';
import { YubiDialog } from '../../dialogs/yubi/yubi.dialog';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
	MatSnackBar,
	MatSnackBarConfig,
	MatSnackBarRef,
} from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';
import { AccionService } from '../../_services/_index';
import { MessagingService } from '../../_services/messaging.service';
import { ScriptLoaderService } from '../../_services/utils/script-loader.service';

@Component({
	selector: 'login',
	templateUrl: 'login.template.html',
})
export class LoginComponent implements OnInit {
	username: string = '';
	password: string = '';

	position = 'below';

	loading = false;
	returnUrl: string;
	returnParams: any;
	errorMsg: string;

	success: boolean = false;

	perfiles: Perfil[] = undefined;
	resultadoBusquedaPerfiles: Perfil[] = [];

	selectedPerfil: Perfil = undefined;

	test: boolean = false;

	keyword: string = '';

	loginFlag: boolean = false;
	tempPerfiles: Perfil[] = undefined;
	message;

	indexPerfilMarcado = 0;

	urlInicialDefault: string = '/app';

	anio: number = new Date().getFullYear();

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		public dialog: MatDialog,
		private sessionService: SessionService,
		public accionService: AccionService,
		public messagingService: MessagingService,
		public scriptLoader: ScriptLoaderService // private saikuService: SaikuService
	) {}

	ngOnInit() {
		if (!this.scriptLoader.isLoaded('lhcInterno')) {
			this.scriptLoader.load('lhcExterno');
		}
		this.esCambioDePerfil();
		this.sessionService.getSessionActive().pipe(
			map((loggedIn) => {
				if (loggedIn.Succeed) {
					this.router.navigate([
						this.sessionService.obtenerUrlInicial(),
					]);
				}
			})
		);
		this.route.queryParams.subscribe((params) => {
			this.returnUrl =
				this.route.snapshot.queryParams['returnUrl'] || null; // |S| /app/inicio
			var params = Object.assign({}, this.route.snapshot.queryParams);
			delete params['returnUrl'];
			this.returnParams = params;
		});
	}

	@HostListener('document:keydown', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		if (this.success) {
			if (event.keyCode == 13) {
				//Enter
				this.ingresar();
			} else if (event.keyCode == 38) {
				//Up
				if (this.indexPerfilMarcado > 0) {
					this.indexPerfilMarcado--;
				} else {
					this.indexPerfilMarcado =
						this.resultadoBusquedaPerfiles.length - 1;
				}
			} else if (event.keyCode == 40) {
				//Down
				if (
					this.indexPerfilMarcado <
					this.resultadoBusquedaPerfiles.length - 1
				) {
					this.indexPerfilMarcado++;
				} else {
					this.indexPerfilMarcado = 0;
				}
			}
		}
	}

	public login(): void {
		this.loading = true;

		if (this.username && this.password) {
			this.sessionService.login(this.username, this.password).subscribe(
				(response) => {
					if (response.Succeed) {
						if (response.Code == 0) {
							this.perfiles = response.Data;
							// Para producción, si hay un solo perfil, lo seteo default
							if (this.perfiles.length == 1) {
								this.selectedPerfil = this.perfiles[0];
								this.resultadoBusquedaPerfiles = this.perfiles;
								this.ingresar();
							} else {
								this.resultadoBusquedaPerfiles = this.perfiles;
								this.selectedPerfil =
									this.resultadoBusquedaPerfiles[0];
								this.switchPage();
							}
							this.errorMsg = '';
						} else {
							this.perfiles = response.Data;
							this.tempPerfiles = response.Data;
							this.openYubiDialog();
						}
					} else {
						this.errorMsg = response.Message;
					}
				},
				(error) => {
					this.errorMsg = error;
					this.errorMsg.replace('Error: ', '');
				},
				() => {
					this.loading = false;
					this.loginFlag = true;
				}
			);
		} else {
			this.errorMsg = 'Hay campos vacíos';
		}
	}

	openYubiDialog(): void {
		let dialogRef = this.dialog.open(YubiDialog, {
			width: '250px',
			panelClass: 'yubiDialog',
			data: {
				title: 'Guardar mix para',
				content: 'Ingresa la fecha para este nuevo mix',
			},
		});

		dialogRef.afterClosed().subscribe((result) => {
			if (result) {
				// this.perfiles = this.tempPerfiles;
				// Para producción, si hay un solo perfil, lo seteo default
				if (environment.production) {
					if (this.perfiles.length == 1) {
						this.selectedPerfil = this.perfiles[0];
						this.resultadoBusquedaPerfiles = this.perfiles;
						this.ingresar();
					} else {
						this.resultadoBusquedaPerfiles = this.perfiles;
						this.switchPage();
					}
				} else {
					// Para dev
					this.resultadoBusquedaPerfiles = this.perfiles;
					this.switchPage();
				}
				this.errorMsg = '';
			} else {
				this.errorMsg = 'Validacion OTP incompleta, Vuelva a ingresar.';
			}
		});
	}
	public ingresar(index?): void {
		if (index) {
			this.indexPerfilMarcado = index;
		}
		this.selectedPerfil =
			this.resultadoBusquedaPerfiles[this.indexPerfilMarcado];
		if (this.selectedPerfil) {
			this.sessionService
				.ingresar(this.username, this.password, this.selectedPerfil)
				.subscribe(
					(response) => {
						if (response.Succeed) {
							this.sessionService.setCurrentUser(response.Data);
							this.navegarPaginaInicial();
						} else {
							this.errorMsg = response.Message;
						}
					},
					(error) => {
						this.errorMsg = error;
						this.errorMsg.replace('Error: ', '');
					},
					() => {
						this.loading = false;
						this.loginFlag = false;
					}
				);
		} else {
			this.errorMsg = 'No ha seleccionado un perfil';
		}
	}

	navegarPaginaInicial() {
		console.log(this.returnUrl);
		if (!this.returnUrl) {
			this.returnUrl = this.sessionService.obtenerUrlInicial();
			console.log(this.sessionService.obtenerUrlInicial());
		}
		localStorage.removeItem('rutas');
		localStorage.setItem('informesVistos', '0');
		this.router.navigate([this.returnUrl], {
			queryParams: this.returnParams,
		});
	}

	public esCambioDePerfil(): void {
		this.sessionService.esCambioDePerfil().subscribe(
			(response) => {
				if (response.Succeed) {
					if (response.Data) {
						this.perfiles = response.Data;
						this.success = true;
						localStorage.setItem('informesVistos', '0');
						this.resultadoBusquedaPerfiles = this.perfiles;
					}
				} else {
					this.errorMsg = response.Message;
				}
			},
			(error) => {
				this.errorMsg = error;
				this.errorMsg.replace('Error: ', '');
			},
			() => {
				this.loading = false;
				this.loginFlag = false;
			}
		);
	}

	public switchPage(): void {
		this.success = !this.success;
	}

	public seleccionarPerfil(index: number): void {
		this.indexPerfilMarcado = index;
	}

	// Buscar atributos
	public buscarPerfiles(event): void {
		if (event.keyCode == 38 || event.keyCode == 40) {
			return;
		}
		if (this.keyword != '') {
			this.resultadoBusquedaPerfiles = this.perfiles.filter((perfil) =>
				perfil.niceName
					.toLocaleLowerCase()
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
					.includes(this.keyword.toLocaleLowerCase())
			);
		} else {
			this.resultadoBusquedaPerfiles = this.perfiles;
		}
		this.indexPerfilMarcado = 0;
	}

	logout() {
		// this.saikuService.saikuLogout().subscribe(
		//   res => {},
		//   () => {},
		//   () => {}
		// );
		this.sessionService.logout().subscribe(
			(response) => {
				if (response.Succeed) {
					this.saveDatosNavegacion();
					this.sessionService.removeCurrentUser();
					this.success = false;
				}
			},
			() => null, // Error
			() => this.router.navigate(['/login'])
		);
	}

	public saveDatosNavegacion(): boolean {
		let idCliente: number = Number(localStorage.getItem('idCliente'));
		let rutas: any = JSON.parse(localStorage.getItem('rutas'));
		if (!rutas) return false;
		if (!rutas[idCliente]) rutas[idCliente] = {};
		let datosNavegacion: string = JSON.stringify(rutas[idCliente]);
		this.savePaginasDataByIdCliente(idCliente, datosNavegacion);

		return true;
	}

	public savePaginasDataByIdCliente(
		idCliente: number,
		datosNavegacion: string
	) {
		if (
			this.sessionService.getCurrentUser() &&
			this.sessionService.getCurrentUser().perfil
		) {
			this.accionService
				.savePaginasDataByIdCliente(idCliente, datosNavegacion)
				.subscribe((res) => {
					if (res.Succeed) {
						//localStorage.setItem('rutas', JSON.stringify(res.Data));
					}
				});
		}
	}
}
